import { styled } from '@clickcease/cc-client-components-lib'

export const AccountSettingsStyled = styled('div', {
  width: 'calc(100% - 60px)',
  display: 'flex',
  flexDirection: 'column',
  padding: '20px',
  background: '#ffffff',
  boxShadow: 'rgb(102 102 102 / 5%) 0px 0px 30px',
  minHeight: '84vh',
  borderRadius: '12px',
  height: 'auto',
  marginBottom: '20px',

  '@laptop': {
    height: 'auto',
  },
})
